import _ from 'lodash'

export default ({
  collection,
  theme: { [collection]: types },
  type: { name },
}) => _.find(types, { name }) || {}
